module.exports = __webpack_public_path__ + "img/feven_horizontal_blue.9d2f5239.svg";